module.exports = __webpack_public_path__ + "img/lsj2.6040fd7d.png";